import React from 'react';
import PropTypes from 'prop-types';
import SMStream from '../streams/SMStream2';
import PlayersList from './PlayersList';

const smWidgets = ({ teamId }) => {
    return [
        {
            name: 'TeamSquadListSMWidget',
            props: {
                teamId,
                layoutType: 'list',
                groupBy: true,
                position: 'allGroup',
                subTextType: 'clubName',
                showCoach: true,
                showInjSusp: true
            }
        },
        {
            name: 'TeamSquadListSMWidget',
            props: {
                teamId,
                layoutType: 'grid',
                groupBy: true,
                position: 'allGroup',
                subTextType: 'clubName',
                showCoach: true,
                showInjSusp: true
            }
        }
    ];
};

function TeamSquadSMB({ params }) {
    return (
        <div>
            <PlayersList params={params} />
            <SMStream smWidgets={smWidgets(params)} title="Team Squad" />
        </div>
    );
}

TeamSquadSMB.propTypes = {
    params: PropTypes.shape({
        tournamentId: PropTypes.string.isRequired,
        teamId: PropTypes.string.isRequired,
        seasonId: PropTypes.string.isRequired
    }).isRequired,
    children: PropTypes.any
};

export default TeamSquadSMB;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/sm/pages/TeamSquadSMB.js
 **/